import { render, staticRenderFns } from "./Coupuser.vue?vue&type=template&id=b9a2d23a&scoped=true"
import script from "./Coupuser.vue?vue&type=script&lang=js"
export * from "./Coupuser.vue?vue&type=script&lang=js"
import style0 from "./Coupuser.vue?vue&type=style&index=0&id=b9a2d23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a2d23a",
  null
  
)

export default component.exports